import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const AiDriveSearchSlice = createSlice({
  name: "AiDriveSearchSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    AiDriveSearch: (state, _: PayloadAction<any>) => { 
      state.isLoading = true;
    },
    successAiDriveSearch: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureAiDriveSearch: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAiDriveSearch: (state) => {
      state.data = {};
    },
  },
});

export const {
  AiDriveSearch,
  successAiDriveSearch,
  failureAiDriveSearch,
  clearAiDriveSearch,
} = AiDriveSearchSlice.actions;

export default AiDriveSearchSlice.reducer;
